export default "__VITE_ASSET__CbwB1Z7H__"